"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCancelOrder = exports.useSubmitOrderFlow = exports.useApproveToken = exports.useUnwrapToken = exports.useWrapOnly = exports.useWrapToken = exports.useCreateOrder = void 0;
var web3_candies_1 = require("@defi.org/web3-candies");
var react_query_1 = require("@tanstack/react-query");
var context_1 = require("../context/context");
var hooks_1 = require("./hooks");
var query_1 = require("./query");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var utils_1 = require("../utils");
var react_1 = require("react");
var analytics_1 = require("../analytics");
var actions_1 = require("../context/actions");
var moment_1 = __importDefault(require("moment"));
var lib_1 = require("./lib");
var types_1 = require("../types");
var useCreateOrder = function () {
    var _a = query_1.query.useGasPrice(), maxFeePerGas = _a.maxFeePerGas, priorityFeePerGas = _a.priorityFeePerGas;
    var _b = (0, context_1.useTwapContext)(), askDataParams = _b.askDataParams, account = _b.account, dstToken = _b.dstToken, config = _b.config;
    var dstMinAmountOut = (0, lib_1.useDstMinAmountOut)().amount;
    var srcChunkAmount = (0, lib_1.useSrcChunkAmount)().amount;
    var deadline = (0, lib_1.useDeadline)().millis;
    var fillDelayMillisUi = (0, lib_1.useFillDelay)().millis;
    var srcAmount = (0, lib_1.useSrcAmount)().amount;
    var onTxHash = actions_1.stateActions.useOnTxHash().onCreateOrderTxHash;
    var twapContract = (0, hooks_1.useTwapContract)();
    var estimatedDelayBetweenChunksMillis = (0, hooks_1.useEstimatedDelayBetweenChunksMillis)();
    return (0, react_query_1.useMutation)(function (srcToken) { return __awaiter(void 0, void 0, void 0, function () {
        var fillDelaySeconds, askData, askParams, ask, tx, orderId, txHash;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    analytics_1.analytics.updateAction("create");
                    fillDelaySeconds = (fillDelayMillisUi - estimatedDelayBetweenChunksMillis) / 1000;
                    if (!dstToken) {
                        throw new Error("dstToken is not defined");
                    }
                    if (!twapContract) {
                        throw new Error("twapContract is not defined");
                    }
                    if (!account) {
                        throw new Error("account is not defined");
                    }
                    askData = config.exchangeType === "PangolinDaasExchange" ? (0, web3_candies_1.web3)().eth.abi.encodeParameters(["address"], askDataParams || []) : [];
                    askParams = [
                        config.exchangeAddress,
                        srcToken.address,
                        dstToken.address,
                        (0, bignumber_js_1.default)(srcAmount).toFixed(0),
                        (0, bignumber_js_1.default)(srcChunkAmount).toFixed(0),
                        (0, bignumber_js_1.default)(dstMinAmountOut).toFixed(0),
                        (0, bignumber_js_1.default)(deadline).div(1000).toFixed(0),
                        (0, bignumber_js_1.default)(config.bidDelaySeconds).toFixed(0),
                        (0, bignumber_js_1.default)(fillDelaySeconds).toFixed(0),
                        askData,
                    ];
                    console.log("create order args:", {
                        exchangeAddress: config.exchangeAddress,
                        srcToken: srcToken.address,
                        dstToken: dstToken.address,
                        srcAmount: (0, bignumber_js_1.default)(srcAmount).toFixed(0),
                        srcChunkAmount: (0, bignumber_js_1.default)(srcChunkAmount).toFixed(0),
                        dstMinAmountOut: (0, bignumber_js_1.default)(dstMinAmountOut).toFixed(0),
                        deadline: (0, bignumber_js_1.default)(deadline).div(1000).toFixed(0),
                        bidDelaySeconds: (0, bignumber_js_1.default)(config.bidDelaySeconds).toFixed(0),
                        fillDelaySeconds: (0, bignumber_js_1.default)(fillDelaySeconds).toFixed(0),
                        priorityFeePerGas: priorityFeePerGas.toString(),
                        maxFeePerGas: maxFeePerGas.toString(),
                    });
                    ask = twapContract.methods.ask(askParams);
                    return [4 /*yield*/, (0, web3_candies_1.sendAndWaitForConfirmations)(ask, {
                            from: account,
                            maxPriorityFeePerGas: priorityFeePerGas || web3_candies_1.zero,
                            maxFeePerGas: maxFeePerGas,
                        }, undefined, undefined, {
                            onTxHash: onTxHash,
                        })];
                case 1:
                    tx = _a.sent();
                    orderId = Number(tx.events.OrderCreated.returnValues.id);
                    txHash = tx.transactionHash;
                    analytics_1.analytics.onCreateOrderSuccess(orderId, txHash);
                    (0, utils_1.logger)("order created:", "orderId:", orderId, "txHash:", txHash);
                    return [2 /*return*/, {
                            orderId: orderId,
                            txHash: txHash,
                        }];
            }
        });
    }); }, {
        onError: function (error) {
            (0, utils_1.logger)("order create failed:", error);
            analytics_1.analytics.onTxError(error, "create");
        },
    });
};
exports.useCreateOrder = useCreateOrder;
var useWrapToken = function () {
    var srcAmount = (0, lib_1.useSrcAmount)().amount;
    var _a = (0, context_1.useTwapContext)(), config = _a.config, account = _a.account;
    var network = (0, hooks_1.useNetwork)();
    var wrapOnly = (0, lib_1.useShouldOnlyWrap)();
    var onTxHash = actions_1.stateActions.useOnTxHash().onWrapTxHash;
    var _b = query_1.query.useGasPrice(), priorityFeePerGas = _b.priorityFeePerGas, maxFeePerGas = _b.maxFeePerGas;
    return (0, react_query_1.useMutation)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var txHash;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    txHash = "";
                    if (!config) {
                        throw new Error("config is not defined");
                    }
                    if (!network) {
                        throw new Error("network is not defined");
                    }
                    if (!account) {
                        throw new Error("account is not defined");
                    }
                    (0, utils_1.logger)("wrapping token");
                    analytics_1.analytics.updateAction(wrapOnly ? "wrap-only" : "wrap");
                    return [4 /*yield*/, (0, web3_candies_1.sendAndWaitForConfirmations)((0, web3_candies_1.erc20)(network.wToken.symbol, network.wToken.address, network.wToken.decimals, web3_candies_1.iwethabi).methods.deposit(), {
                            from: account,
                            maxPriorityFeePerGas: priorityFeePerGas,
                            maxFeePerGas: maxFeePerGas,
                            value: srcAmount,
                        }, undefined, undefined, {
                            onTxHash: function (hash) {
                                txHash = hash;
                                onTxHash(hash);
                            },
                        })];
                case 1:
                    _a.sent();
                    (0, utils_1.logger)("token wrap success:", txHash);
                    analytics_1.analytics.onWrapSuccess(txHash);
                    return [2 /*return*/];
            }
        });
    }); }, {
        onError: function (error) {
            (0, utils_1.logger)("token wrap failed:", error);
            analytics_1.analytics.onTxError(error, wrapOnly ? "wrap-only" : "wrap");
        },
    });
};
exports.useWrapToken = useWrapToken;
var useWrapOnly = function () {
    var mutateAsync = (0, exports.useWrapToken)().mutateAsync;
    var onSuccess = (0, hooks_1.useResetAfterSwap)();
    return (0, react_query_1.useMutation)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    analytics_1.analytics.updateAction("wrap-only");
                    return [4 /*yield*/, mutateAsync()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, onSuccess()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
};
exports.useWrapOnly = useWrapOnly;
var useUnwrapToken = function () {
    var account = (0, context_1.useTwapContext)().account;
    var _a = query_1.query.useGasPrice(), priorityFeePerGas = _a.priorityFeePerGas, maxFeePerGas = _a.maxFeePerGas;
    var onSuccess = (0, hooks_1.useResetAfterSwap)();
    var srcAmount = (0, lib_1.useSrcAmount)().amount;
    var onTxHash = actions_1.stateActions.useOnTxHash().onUnwrapTxHash;
    var network = (0, hooks_1.useNetwork)();
    return (0, react_query_1.useMutation)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var txHash;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    txHash = "";
                    if (!network) {
                        throw new Error("network is not defined");
                    }
                    if (!account) {
                        throw new Error("account is not defined");
                    }
                    analytics_1.analytics.updateAction("unwrap");
                    return [4 /*yield*/, (0, web3_candies_1.sendAndWaitForConfirmations)((0, web3_candies_1.erc20)(network.wToken.symbol, network.wToken.address, network.wToken.decimals, web3_candies_1.iwethabi).methods.withdraw((0, bignumber_js_1.default)(srcAmount).toFixed(0)), { from: account, maxPriorityFeePerGas: priorityFeePerGas, maxFeePerGas: maxFeePerGas }, undefined, undefined, {
                            onTxHash: function (hash) {
                                txHash = hash;
                                onTxHash(hash);
                            },
                        })];
                case 1:
                    _a.sent();
                    analytics_1.analytics.onUnwrapSuccess(txHash);
                    return [4 /*yield*/, onSuccess()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onError: function (error) {
            analytics_1.analytics.onTxError(error, "unwrap");
        },
    });
};
exports.useUnwrapToken = useUnwrapToken;
var useApproveToken = function () {
    var onTxHash = actions_1.stateActions.useOnTxHash().onApproveTxHash;
    var _a = (0, context_1.useTwapContext)(), config = _a.config, account = _a.account, isExactAppoval = _a.isExactAppoval;
    var srcAmount = (0, lib_1.useSrcAmount)().amount;
    var _b = query_1.query.useGasPrice(), priorityFeePerGas = _b.priorityFeePerGas, maxFeePerGas = _b.maxFeePerGas;
    var approvalAmount = isExactAppoval ? srcAmount : web3_candies_1.maxUint256;
    return (0, react_query_1.useMutation)(function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var txHash, contract;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!account) {
                        throw new Error("account is not defined");
                    }
                    (0, utils_1.logger)("approving token...");
                    analytics_1.analytics.updateAction("approve");
                    txHash = "";
                    contract = (0, web3_candies_1.erc20)(token.symbol, token.address, token.decimals);
                    return [4 /*yield*/, (0, web3_candies_1.sendAndWaitForConfirmations)(contract.methods.approve(config.twapAddress, (0, bignumber_js_1.default)(approvalAmount).toFixed(0)), {
                            from: account,
                            maxPriorityFeePerGas: priorityFeePerGas,
                            maxFeePerGas: maxFeePerGas,
                        }, undefined, undefined, {
                            onTxHash: function (value) {
                                onTxHash(value);
                                txHash = value;
                            },
                        })];
                case 1:
                    _a.sent();
                    (0, utils_1.logger)("token approve success:", txHash);
                    analytics_1.analytics.onApproveSuccess(txHash);
                    return [2 /*return*/];
            }
        });
    }); }, {
        onError: function (error) {
            (0, utils_1.logger)("token approve failed:", error);
            analytics_1.analytics.onTxError(error, "approve");
        },
    });
};
exports.useApproveToken = useApproveToken;
var useOnSuccessCallback = function () {
    var _a = (0, context_1.useTwapContext)(), onTxSubmitted = _a.onTxSubmitted, config = _a.config, srcToken = _a.srcToken, dstToken = _a.dstToken;
    var addOrder = query_1.query.useAddNewOrder();
    var swapData = (0, lib_1.useSwapData)();
    var onOrderCreated = actions_1.stateActions.useOnOrderCreated();
    var reset = (0, hooks_1.useResetAfterSwap)();
    var estimatedDelayBetweenChunksMillis = (0, hooks_1.useEstimatedDelayBetweenChunksMillis)();
    return (0, react_1.useCallback)(function (order) {
        var fillDelaySeconds = (swapData.fillDelay.millis - estimatedDelayBetweenChunksMillis) / 1000;
        onOrderCreated();
        addOrder({
            srcTokenAddress: srcToken === null || srcToken === void 0 ? void 0 : srcToken.address,
            dstTokenAddress: dstToken === null || dstToken === void 0 ? void 0 : dstToken.address,
            srcAmount: swapData.srcAmount.amount,
            createdAt: (0, moment_1.default)().unix().valueOf(),
            id: order.orderId,
            txHash: order.txHash,
            deadline: (0, moment_1.default)(swapData.deadline.millis).unix(),
            srcBidAmount: swapData.srcChunkAmount.amount,
            dstMinAmount: swapData.dstMinAmount.amount,
            fillDelay: fillDelaySeconds,
            totalChunks: swapData.chunks,
            status: types_1.Status.Open,
            srcToken: srcToken,
            dstToken: dstToken,
            exchange: config.exchangeAddress,
        });
        onTxSubmitted === null || onTxSubmitted === void 0 ? void 0 : onTxSubmitted({
            srcToken: srcToken,
            dstToken: dstToken,
            srcAmount: swapData.srcAmount.amount,
            dstUSD: swapData.amountUsd.dstUsd || "",
            dstAmount: swapData.outAmount.amount || "",
            txHash: order.txHash,
        });
        reset();
    }, [srcToken, dstToken, onTxSubmitted, onOrderCreated, reset, config, swapData, estimatedDelayBetweenChunksMillis]);
};
var useSubmitAnalytics = function () {
    var swapData = (0, lib_1.useSwapData)();
    return (0, react_1.useCallback)(function () {
        analytics_1.analytics.onSubmitOrder(swapData);
    }, [swapData]);
};
var useSubmitOrderFlow = function () {
    var _a = (0, context_1.useTwapContext)(), minNativeTokenBalance = _a.minNativeTokenBalance, updateState = _a.updateState, state = _a.state, srcToken = _a.srcToken;
    var swapState = state.swapState, swapStep = state.swapStep, createOrdertxHash = state.createOrdertxHash, approveTxHash = state.approveTxHash, wrapTxHash = state.wrapTxHash, wrapSuccess = state.wrapSuccess;
    var haveAllowance = query_1.query.useAllowance().data;
    var ensureNativeBalance = query_1.query.useMinNativeTokenBalance(minNativeTokenBalance).ensureData;
    var shouldWrap = (0, lib_1.useShouldWrap)();
    var onSuccessCallback = useOnSuccessCallback();
    var network = (0, hooks_1.useNetwork)();
    var wToken = network === null || network === void 0 ? void 0 : network.wToken;
    var nativeSymbol = network === null || network === void 0 ? void 0 : network.native.symbol;
    var refetchAllowance = query_1.query.useAllowance().refetch;
    var submitAnalytics = useSubmitAnalytics();
    var nativeToWrapped = (0, actions_1.useSwitchNativeToWrapped)();
    var approve = (0, exports.useApproveToken)().mutateAsync;
    var wrapToken = (0, exports.useWrapToken)().mutateAsync;
    var createOrder = (0, exports.useCreateOrder)().mutateAsync;
    var getHasAllowance = (0, hooks_1.useGetHasAllowance)();
    var swapData = (0, lib_1.useSwapData)();
    var srcAmount = swapData.srcAmount;
    var mutate = (0, react_query_1.useMutation)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var hasMinNativeTokenBalance, token, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!srcToken) {
                        throw new Error("Please select a token to swap");
                    }
                    if (!wToken) {
                        throw new Error("WToken not defined");
                    }
                    (0, utils_1.logger)("Create order request");
                    updateState({ swapState: "loading", swapData: swapData });
                    submitAnalytics();
                    if (!minNativeTokenBalance) return [3 /*break*/, 2];
                    return [4 /*yield*/, ensureNativeBalance()];
                case 1:
                    hasMinNativeTokenBalance = _a.sent();
                    if (!hasMinNativeTokenBalance.data) {
                        throw new Error("Insufficient ".concat(nativeSymbol, " balance, you need at least ").concat(minNativeTokenBalance).concat(nativeSymbol, " to cover the transaction fees."));
                    }
                    _a.label = 2;
                case 2:
                    token = srcToken;
                    if (!shouldWrap) return [3 /*break*/, 4];
                    updateState({ swapStep: "wrap" });
                    return [4 /*yield*/, wrapToken()];
                case 3:
                    _a.sent();
                    updateState({ wrapSuccess: true });
                    token = wToken;
                    _a.label = 4;
                case 4:
                    if (!!haveAllowance) return [3 /*break*/, 7];
                    updateState({ swapStep: "approve" });
                    return [4 /*yield*/, approve(token)];
                case 5:
                    _a.sent();
                    return [4 /*yield*/, getHasAllowance(token, srcAmount.amount)];
                case 6:
                    res = _a.sent();
                    if (!res) {
                        throw new Error("Insufficient allowance to perform the swap. Please approve the token first.");
                    }
                    updateState({ approveSuccess: true });
                    _a.label = 7;
                case 7:
                    updateState({ swapStep: "createOrder" });
                    return [2 /*return*/, createOrder(token)];
            }
        });
    }); }, {
        onError: function (error) {
            if (wrapSuccess) {
                nativeToWrapped();
            }
            if ((0, utils_1.isTxRejected)(error)) {
                updateState({ swapState: undefined, swapData: undefined });
            }
            else {
                updateState({ swapState: "failed" });
            }
        },
        onSuccess: function (data) {
            onSuccessCallback(data);
        },
        onSettled: function () {
            refetchAllowance();
        },
    });
    var error = !mutate.error ? undefined : mutate.error.message || "Failed to create order";
    return __assign(__assign({}, mutate), { swapState: swapState, error: error, swapStep: swapStep, createOrdertxHash: createOrdertxHash, approveTxHash: approveTxHash, wrapTxHash: wrapTxHash });
};
exports.useSubmitOrderFlow = useSubmitOrderFlow;
var useCancelOrder = function () {
    var refetch = query_1.query.useOrdersHistory().refetch;
    var _a = query_1.query.useGasPrice(), priorityFeePerGas = _a.priorityFeePerGas, maxFeePerGas = _a.maxFeePerGas;
    var account = (0, context_1.useTwapContext)().account;
    var twapContract = (0, hooks_1.useTwapContract)();
    var onCancelOrder = query_1.query.useUpdateOrderStatusToCanceled();
    return (0, react_query_1.useMutation)(function (orderId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!twapContract) {
                        throw new Error("twap contract not defined");
                    }
                    if (!account) {
                        throw new Error("account not defined");
                    }
                    (0, utils_1.logger)("canceling order...", orderId);
                    analytics_1.analytics.onCancelOrder(orderId);
                    return [4 /*yield*/, (0, web3_candies_1.sendAndWaitForConfirmations)(twapContract.methods.cancel(orderId), {
                            from: account,
                            maxPriorityFeePerGas: priorityFeePerGas,
                            maxFeePerGas: maxFeePerGas,
                        })];
                case 1:
                    _a.sent();
                    console.log("order canceled");
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function (_, orderId) {
            (0, utils_1.logger)("order canceled");
            analytics_1.analytics.onCancelOrderSuccess();
            onCancelOrder(orderId);
        },
        onError: function (error) {
            console.log("cancel error order", error);
            analytics_1.analytics.onTxError(error, "cancel");
        },
    });
};
exports.useCancelOrder = useCancelOrder;
